var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-projects"},[_c('b-table',{staticClass:"availableProjects",attrs:{"items":_vm.projects,"fields":_vm.fields,"show-empty":"","selectable":"","hover":""},on:{"row-clicked":_vm.rowClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }